<template>
    <svg width="142" height="121" viewBox="0 0 142 121" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M119.01 104.384L118.224 118.022L104.076 112.405L103.485 112.601C94.277 115.653 84.1251 116.21 74.0252 113.641C45.882 106.482 28.8706 77.8636 36.0293 49.7213C43.1881 21.579 71.8059 4.5666 99.9499 11.7257C128.092 18.8844 145.104 47.503 137.945 75.6452C134.986 87.2779 128.357 96.9986 119.614 103.908L119.01 104.384ZM119.796 120.488L120.675 105.25C129.701 98.117 136.548 88.0775 139.603 76.0671C146.995 47.0089 129.43 17.459 100.372 10.0673C71.3118 2.67516 41.7626 20.2413 34.3709 49.2995C26.9792 78.3577 44.5442 107.908 73.6033 115.299C84.031 117.952 94.5161 117.377 104.023 114.225L119.796 120.488Z"
            fill="#FFEEEB"
        />
        <path
            d="M45.4459 1.34612C15.9311 6.62741 -3.71502 34.8366 1.56627 64.3514C3.74915 76.5505 9.85565 87.0567 18.3458 94.8211L18.1254 110.083L34.3078 104.971C43.5636 108.799 53.9802 110.127 64.5717 108.232C94.0874 102.95 113.734 74.7413 108.452 45.2265C103.171 15.7116 74.9625 -3.9355 45.4459 1.34612Z"
            fill="#FFEEEB"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M73.5198 79.3402L32.2847 38.1042L40.15 30.239L81.3851 71.475L73.5198 79.3402Z"
            fill="#FF907C"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M32.2847 71.4751L73.5198 30.24L81.385 38.1053L40.1499 79.3403L32.2847 71.4751Z"
            fill="#FF907C"
        />
    </svg>
</template>
<script>
export default {
    name: "NoActiveConversation",
};
</script>
